import { registerPlugin } from '@capacitor/core';
import logger from '../utils/logger';

/**
 * Capacitor wrapper for the native AppUpdate plugin.
 *
 * This is an Android-only feature. The iOS equivalent is intentionally not
 * implemented here and is tracked by the TODOs in the consuming hook and UI.
 */
const AppUpdate = registerPlugin('AppUpdate');

/**
 * Check whether a newer version is available on Google Play.
 * @returns {Promise<{ updateAvailable: boolean, availableVersionCode: number|null }>}
 */
export async function checkForUpdate() {
  try {
    const result = await AppUpdate.check();
    return {
      updateAvailable: !!result.updateAvailable,
      availableVersionCode: result.availableVersionCode ?? null,
    };
  } catch (error) {
    logger.error('App update check failed:', error);
    throw error;
  }
}

/**
 * Start the Google Play flexible in-app update flow.
 * @returns {Promise<void>}
 */
export async function startFlexibleUpdate() {
  try {
    await AppUpdate.startFlexibleUpdate();
  } catch (error) {
    logger.error('Failed to start flexible update:', error);
    throw error;
  }
}

/**
 * Complete a flexible update that has finished downloading.
 * @returns {Promise<void>}
 */
export async function completeFlexibleUpdate() {
  try {
    await AppUpdate.completeFlexibleUpdate();
  } catch (error) {
    logger.error('Failed to complete flexible update:', error);
    throw error;
  }
}
